import { CircularProgress, Fab, Theme, withStyles } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import i18n from 'i18next'
import { FC, useState } from 'react'
import { CreateApartment } from '../../../actions/types'
import { getCurrentLanguage } from '../../../translations/i18n'
import { MuiClasses } from '../../../types'

const styles = ({ breakpoints, spacing }: Theme) => ({
  fabDivTop: {
    zIndex: 999,
    display: 'none',
    [breakpoints.only('xs')]: {
      display: 'initial',
      marginBottom: '0.5rem',
      //maxWidth: '379px',
      //marginRight: '16px',
      //minWidth: '100%',
      width: '100%',
      '& > span': {
        width: '100%'
      },
      '& button': {
        //height: 'auto !important',
        padding: '6px',
        width: '100%'
      }
    }
  },
  fabDivBottom: {
    zIndex: 999,
    height: '36px',
    [breakpoints.up('sm')]: {
      position: 'fixed' as const,
      bottom: spacing(2),
      right: spacing(3)
    },
    [breakpoints.only('xs')]: {
      display: 'none',

      bottom: spacing(2),
      right: spacing(1)
    }
  },
  fab: {
    minWidth: '180px',
    padding: '0 30px',
    height: '36px !important',
    borderRadius: '4px !important',
    background: '#fff',
    color: '#4f9b44',
    border: '2px dashed #4f9b44',
    boxShadow: '0px 3px 6px rgba(0,0,0,0.16)',
    '&:hover': {
      backgroundColor: '#f6fff4'
    },
    [breakpoints.only('xs')]: {
      height: '46px !important',
      //width: '100% !important',
      marginTop: '0.6rem',
      //marginBottom: '0.1rem',
    }
  },
  applicantsButton: {
    zIndex: 999,
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    maxWidth: '370px',
    [breakpoints.up('sm')]: {
      position: 'fixed' as const,
      top: '85px',
      right: getCurrentLanguage() == 'en' ? '142px' : '163px'
    },
    [breakpoints.up('md')]: {
      top: '85px',
      right: getCurrentLanguage() == 'en' ? '145px' : '167px'
    },
    [breakpoints.up('lg')]: {
      top: '85px',
      right: getCurrentLanguage() == 'en' ? '148px' : '170px'
    },
    [breakpoints.only('xs')]: {
      //width: 'calc(100% - 20px)',
      bottom: spacing(2),
      width: '100%',
      maxWidth: '400px',
    }
  },
  centerHorizontally: {
    display: 'flex',
    justifyContent: 'center',
  },
  addApt: {
    width: '100%',
    maxWidth: '370px',
    margin: '0 auto',
    [breakpoints.down('sm')]: {
      maxWidth: '400px'
    }
  },
  addIcon: {
    marginRight: spacing(1),
    color: '#4f9b44'
  }
})

interface UserApartmentsToolbarProps {
  classes: MuiClasses
  createApartment: CreateApartment
  t: i18n.TFunction
}

const UserApartmentsToolbar: FC<UserApartmentsToolbarProps> = ({
  classes,
  t,
  createApartment
}) => {
  const [isLoading, setIsLoading] = useState(false)
  return (
    <div className={`${classes.container} ${classes.centerHorizontally}`}>
      <div className={classes.addApt}>
        <span className={classes.applicantsButton}>
          <span className={classes.fabDivTop}>
            <Fab
              color='default'
              variant='extended'
              className={classes.fab}
              onClick={() => {
                setIsLoading(true)
                createApartment()
              }}
            >
              {isLoading ? (
                <CircularProgress
                  size={18}
                  style={{ color: '#4f9b44', marginLeft: '5px' }}
                />
              ) : (
                <>
                  <AddIcon className={classes.addIcon} />
                  {t('profile.createApartment')}
                </>
              )}
            </Fab>
          </span>
        </span>

        <span className={classes.fabDivBottom}>
          <Fab
            color='default'
            variant='extended'
            className={classes.fab}
            onClick={() => {
              setIsLoading(true)
              createApartment()
            }}
          >
            {isLoading ? (
              <CircularProgress
                size={18}
                style={{ color: '#4f9b44', marginLeft: '5px' }}
              />
            ) : (
              <>
                <AddIcon className={classes.addIcon} />
                {t('profile.createApartment')}
              </>
            )}
          </Fab>
        </span>
      </div>
    </div>
  )
}

export default withStyles(styles)(UserApartmentsToolbar)
